import Tr from 'translations/Translations';

const createItem = (trKey, value=Tr(trKey)) => ({
	label: Tr(trKey),
	value,
})

export default [
	createItem('yes', 'yes'),
	createItem('no', 'no'),
]

